/**
 * ¯\_(ツ)_/¯ Fixing support for Internet Explorer, Firefox
 * (DOMException exists but calling it's constructor throws error)
 * and other crappy browsers that do not support it natively.
 */
const canUseDOM = !!(
  typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
);

if (canUseDOM) {
  try {
    // tslint:disable-next-line:no-unused-expression
    new window.DOMException();
  } catch (error) {
    // @ts-ignore
    window.DOMException = class DOMException extends Error {
      constructor(public message: string, public name: string) {
        super(message);
      }
    };
  }
}

interface AbortableOptions {
  signal: AbortSignal;
}

export async function abortable<T>(invocable: () => Promise<T>, options: AbortableOptions): Promise<T> {
  let isAborted = options.signal.aborted;
  const abortedError = new DOMException('The operation was aborted.', 'AbortError');
  const onAbortCallback = () => {
    isAborted = true;
  };

  try {
    if (isAborted) {
      throw abortedError;
    }

    options.signal.addEventListener('abort', onAbortCallback);

    const response = await invocable();

    if (isAborted) {
      throw abortedError;
    } else {
      return response;
    }
  } catch (error) {
    throw isAborted ? abortedError : error;
  } finally {
    options.signal.removeEventListener('abort', onAbortCallback);
  }
}
